// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconCheckMark_loader__1_Yzn","root":"IconCheckMark_root__1bhFD"};